import { useCallback, useEffect, useMemo } from 'react';
import { useIsRetail } from '../../../hooks/useIsRetail';
import { useRepInfo } from '../../../hooks/useRepInfo';
import { VerticalAssignableModal } from './VerticalAssignableModal';
import { VerticalReducedOptionsModal } from './VerticalReducedOptionsModal';
import { loadAndOpenSalesChat } from '../../../utils/loadAndOpenSalesChat';
import { trackPurchaseMotionFailure } from '../../../utils/metrics';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { getRepName } from '../../../utils/pql';
import { jsx as _jsx } from "react/jsx-runtime";
const checkIsAssignable = ({
  isAssignable,
  isRetail,
  repInfo
}) => !!(isAssignable && !isRetail && repInfo !== null && repInfo !== void 0 && repInfo.link);
const CommModalContainer = ({
  apiName,
  trackingData,
  upgradeConfig,
  isAssignable,
  onClose
}) => {
  const {
    error: repInfoError,
    loading: repInfoLoading,
    repInfo
  } = useRepInfo();
  const {
    error: isRetailError,
    loading: isRetailLoading,
    isRetail
  } = useIsRetail();
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'TALK_TO_SALES'
  }), [apiName, trackingData, upgradeConfig]);
  const handleClose = useCallback(() => {
    track('communication-methods', Object.assign({
      action: 'closed'
    }, trackingProperties, {
      repName: getRepName(repInfo)
    }));
    onClose();
  }, [trackingProperties, repInfo, onClose]);
  const handleClickChat = useCallback(() => {
    track('communication-methods', Object.assign({
      action: 'clicked unassignable chat button'
    }, trackingProperties));
    loadAndOpenSalesChat({
      apiName,
      trackingData,
      isRetail: isRetail !== null && isRetail !== void 0 ? isRetail : false
    });
    handleClose();
  }, [trackingProperties, apiName, trackingData, isRetail, handleClose]);
  const handleClickCall = useCallback(() => {
    track('communication-methods', Object.assign({
      action: 'clicked unassignable phone button'
    }, trackingProperties));
  }, [trackingProperties]);
  useEffect(() => {
    if (!isRetailLoading && !repInfoLoading) {
      if (isRetailError || repInfoError) {
        trackPurchaseMotionFailure({
          uniqueId: trackingData.uniqueId,
          apiName,
          purchaseMotion: 'TALK_TO_SALES'
        });
      } else {
        const isAssignableClick = checkIsAssignable({
          isAssignable,
          isRetail: isRetail !== null && isRetail !== void 0 ? isRetail : false,
          repInfo
        });
        track('contact-sales-button', Object.assign({
          action: isAssignableClick ? 'clicked' : 'clicked talk to ISC'
        }, trackingProperties, {
          isAssignable: isAssignableClick,
          repName: getRepName(repInfo)
        }));
        if (upgradeConfig) {
          track('interaction', Object.assign({
            action: 'clicked upgrade point',
            isAssignable: isAssignableClick
          }, trackingProperties));
          track('interaction', Object.assign({
            action: 'clicked talk to sales',
            isAssignable: isAssignableClick
          }, trackingProperties));
        }
      }
    }
  }, [apiName, isAssignable, isRetail, isRetailError, isRetailLoading, repInfo, repInfoError, repInfoLoading, trackingData, trackingProperties, upgradeConfig]);
  if (repInfoLoading || isRetailLoading) return null;
  if (!isRetailError && !repInfoError && repInfo && checkIsAssignable({
    isAssignable,
    isRetail,
    repInfo
  })) {
    return /*#__PURE__*/_jsx(VerticalAssignableModal, {
      apiName: apiName,
      repInfo: repInfo,
      trackingData: trackingData,
      upgradeConfig: upgradeConfig,
      onClose: handleClose
    });
  }
  return /*#__PURE__*/_jsx(VerticalReducedOptionsModal, {
    apiName: apiName,
    isRetail: isRetail !== null && isRetail !== void 0 ? isRetail : false,
    trackingData: trackingData,
    upgradeConfig: upgradeConfig,
    onClickChat: handleClickChat,
    onClickCall: handleClickCall,
    onClose: handleClose
  });
};
export default CommModalContainer;